import { useContext } from 'react'
import { Box, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import PremiumInsightsContext from '../PremiumInsightsProvider/Context'
import { Audience, Bucket } from '../types'
import {
  AUDIENCE_FIELD_NAMES,
  AUDIENCE_FIELD_VALUES,
  DATE_RANGE_FIELD_NAMES,
  DATE_RANGE_FIELD_VALUES,
  FIELD_NAMES,
  LABELS,
  LABEL_IDS,
} from '../constants'

export default function InsightsFilters() {
  const { selectedFilters, dispatch } = useContext(PremiumInsightsContext)

  return (
    <Box
      display="flex"
      alignItems="center"
      flexWrap="wrap"
      gridGap={8}
    >
      <Box mr={2}>
        <FormControl variant="outlined">
          <InputLabel id={LABEL_IDS.AUDIENCE}>{LABELS.AUDIENCE}</InputLabel>
          <Select
            labelId={LABEL_IDS.AUDIENCE}
            id={FIELD_NAMES.AUDIENCE}
            value={selectedFilters.audience}
            label={LABELS.AUDIENCE}
            onChange={(e) => {
              dispatch({ type: 'SET_AUDIENCE_FILTER', payload: { audience: e.target.value as Audience } })
            }}
          >
            <MenuItem value={AUDIENCE_FIELD_VALUES.student}>{AUDIENCE_FIELD_NAMES.student}</MenuItem>
            <MenuItem value={AUDIENCE_FIELD_VALUES.parent}>{AUDIENCE_FIELD_NAMES.parent}</MenuItem>
            <MenuItem value={AUDIENCE_FIELD_VALUES.all}>{AUDIENCE_FIELD_NAMES.all}</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Box>
        <FormControl variant="outlined">
          <InputLabel id={LABEL_IDS.DATE_RANGE}>{LABELS.DATE_RANGE}</InputLabel>
          <Select
            labelId={LABEL_IDS.DATE_RANGE}
            id={FIELD_NAMES.DATE_RANGE}
            value={selectedFilters.bucket}
            label={LABELS.DATE_RANGE}
            onChange={(e) => {
              dispatch({ type: 'SET_DATE_RANGE_FILTER', payload: { bucket: e.target.value as Bucket } })
            }}
            renderValue={(value) => DATE_RANGE_FIELD_NAMES[value as Bucket]}
          >
            <MenuItem value={DATE_RANGE_FIELD_VALUES['1y']}>
              <Box>
                {DATE_RANGE_FIELD_NAMES['1y']}
                <p>(July 1 - Today)</p>
              </Box>
            </MenuItem>
            <MenuItem value={DATE_RANGE_FIELD_VALUES['30d']}>{DATE_RANGE_FIELD_NAMES['30d']}</MenuItem>
            <MenuItem value={DATE_RANGE_FIELD_VALUES['90d']}>{DATE_RANGE_FIELD_NAMES['90d']}</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Box>
  )
}
